import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";

export function Field({ label, required, error, children, hint, id }) {
  return (
    <div>
      {label && (
        <label htmlFor={id} className="field-label">
          {label} {required && <span className="text-[color:var(--red)]">*</span>}
        </label>
      )}
      {children}
      {hint && !error && <p className="mt-1 text-xs text-zinc-500">{hint}</p>}
      {error && <p className="field-error" data-testid={`error-${id}`}>{error}</p>}
    </div>
  );
}

export function Honeypot({ value, onChange }) {
  return (
    <div aria-hidden="true" className="absolute -left-[9999px] h-0 w-0 overflow-hidden">
      <label>
        Web siteniz
        <input type="text" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} name="website" />
      </label>
    </div>
  );
}

export function ConsentBox({ id, checked, onChange, error, to, linkText, rest }) {
  return (
    <div>
      <label className="flex cursor-pointer items-start gap-3 text-sm text-zinc-700">
        <input id={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 accent-[color:var(--red)]" data-testid={id} />
        <span>
          {to && <Link to={to} target="_blank" className="font-semibold text-[color:var(--red)] underline">{linkText}</Link>} {rest}
        </span>
      </label>
      {error && <p className="field-error" data-testid={`error-${id}`}>{error}</p>}
    </div>
  );
}

export function SubmitBtn({ loading, children, testid }) {
  return (
    <button type="submit" disabled={loading} className="btn-red w-full !py-4 text-base disabled:opacity-60 sm:w-auto" data-testid={testid}>
      {loading && <Loader2 className="h-4 w-4 animate-spin" />} {children}
    </button>
  );
}

export function SuccessBox({ title, text, testid, children }) {
  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-8 text-center" data-testid={testid}>
      <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" />
      <h2 className="mt-4 text-xl font-bold text-zinc-900">{title}</h2>
      <p className="mt-2 text-sm text-zinc-600">{text}</p>
      {children}
    </div>
  );
}

export const isEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v || "");
export const isPhone = (v) => (v || "").replace(/\D/g, "").length >= 10;
